import { ConditionsConfig } from '../mijn-condities.model';

export const ConditionsConfigs: ConditionsConfig[] = [
    {
        level: 2,
        keyPart: 'overview.products.accounts',
        condition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot',
        businessCondition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot'
    },
    {
        level: 2,
        keyPart: 'overview.products.cancelledAccounts',
        condition: 'hasOnlyCancelledAccounts'
    },
    {
        level: 2,
        keyPart: 'overview.products.cards',
        condition: 'hasOrCanRequestCards',
        businessCondition: 'hasOrCanRequestCardsAndIsZZP'
    },
    {
        level: 2,
        keyPart: 'overview.products.huismap',
        condition: 'hasHuismap',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.products.pegahuismap',
        condition: 'hasPegaHuismap',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.products.mortgages',
        condition: 'hasMortgages'
    },
    {
        level: 2,
        keyPart: 'overview.products.bizcuit',
        condition: 'isBusiness',
        businessCondition: 'hasBizcuitConnection'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.extraDeposit',
        condition: 'hasMortgageWithSavingAttributes',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.products.insurances',
        condition: 'hasInsurances',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.affairs.currentAffairs',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.legal.conditions',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.settings.manageLimits',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.settings.sharingAccess',
        condition: 'hasPaymentAccounts',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.products.addProduct.title',
        condition: 'productCatalogEnabled'
    },
    {
        level: 2,
        keyPart: 'overview.products.addProduct',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'overview.products.productCatalog',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 1,
        keyPart: 'accounts',
        condition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.credit',
        condition: 'hasPaymentAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.changeCounterAccount',
        condition: 'hasSavingsInvestmentLoanAccounts',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.changeCounterAccountBusiness',
        condition: 'isBusiness',
        businessCondition: 'hasSavingsInvestmentLoanAccountsAndIsNotZZP'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.cancelAccount',
        condition: 'hasPaymentSavingsInvestmentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.overdraw',
        condition: 'hasPaymentAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.cancelledAccounts',
        condition: 'hasCancelledAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.bankStatementFrequency',
        condition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.paymentRequests',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.businessCredit',
        condition: 'isBusiness',
        businessCondition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.cancelAccount',
        condition: 'hasPaymentSavingsInvestmentAccountsAndIsZZP'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.downloadAccountStatus',
        condition: 'hasPaymentSavingsInvestmentAccountsOrMortgageWithBouwdepot'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.switchingService',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.download.downloadAccountbalances',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.download.downloadTransactions',
        condition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.others.requestOnlineBankingChild',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.others.forgotDigicode.',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.addressbook',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.autoAanvullen',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.incasso',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.plannedPayments',
        condition: 'hasPaymentSavingsAccounts'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.requestOrEditAutomaticDebit',
        condition: 'hasRSCForAutomaticDebit',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.transfer.paymentBatches',
        condition: 'isBusiness',
        businessCondition: 'hasBatchPayments'
    },
    {
        level: 2,
        keyPart: 'accounts.insight.incomeAndExpenses',
        condition: 'hasPaymentAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.insight.budgets',
        condition: 'hasPaymentAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.insight.balanceChart',
        condition: 'hasPaymentSavingsAccounts',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 1,
        keyPart: 'mortgages',
        condition: 'hasMortgages'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.constructionDepot',
        condition: 'hasConstructionDepotWithNonZeroAmount',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.changeAccount',
        condition: 'hasMortgages',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.adjustInterest',
        condition: 'hasMortgages',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.collateralValue',
        condition: 'hasMortgages',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.provideAddress',
        condition: 'hasBouwdepotWithNonZeroAmount',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'mortgages.dynamic.convertMortgage',
        condition: 'canConvertMortgage',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'privacy.general.consentAi',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'privacy.general.telephonyConsent',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'privacy.general.cookies',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'accounts.selfservice.manageAccess',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'manageAccess.general.addPerson',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'manageAccess.general.removePerson',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.digicode.changeDigicode',
        condition: 'hasDigicode',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.digipas.blockUnblockDigipas',
        condition: 'hasDigipas',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.digipas.otherIssues',
        condition: 'hasDigipas',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'sharingAccess.TAS.IDEAL',
        condition: 'hasIdealProfile'
    },
    {
        level: 2,
        keyPart: 'sharingAccess.TAS.IDIN',
        condition: 'isAdult',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'sharingAccess.TAS.managePermissions',
        condition: 'hasPaymentAccounts'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.digipas.fixDigipasIssues',
        condition: 'isBusiness',
        businessCondition: 'hasDigipas'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.digipas.requestNewDigipas',
        condition: 'isBusiness',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.tokens.authenticationHistory',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.tokens.manageTokens',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'safetyAccess.tokens.onlineBankingChild',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'onlineBankingChild.tokens.forgotDigicode',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'onlineBankingChild.tokens.requestOnlineBankingChild',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 1,
        keyPart: 'betaalpassen',
        condition: 'hasOrCanRequestCards',
        businessCondition: 'hasOrCanRequestCardsAndIsZZP'
    },
    {
        level: 1,
        keyPart: 'general',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 1,
        keyPart: 'notificatieBeheer',
        condition: 'hasPaymentSavingsInvestmentAccounts'
    },
    {
        level: 1,
        keyPart: 'mijn-products',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 1,
        keyPart: 'mijn-products-zzp',
        condition: 'isZZP',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'header.inbox.messages',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'header.inbox.documents',
        condition: 'isNotBusiness',
        businessCondition: 'isZZP'
    },
    {
        level: 2,
        keyPart: 'header.settings.safetyAccess',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'header.settings.personalData',
        condition: 'isNotBusiness',
        businessCondition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'header.settings.businessData',
        condition: 'isBusiness'
    },
    {
        level: 2,
        keyPart: 'header.settings.alerts',
        condition: 'hasPaymentSavingsInvestmentAccounts'
    },
    {
        level: 2,
        keyPart: 'header.settings.messagePreferences',
        condition: 'isNotBusiness'
    },
    {
        level: 2,
        keyPart: 'header.settings.privacy',
        condition: 'isNotBusiness',
        businessCondition: 'isBusiness'
    }
];
